import * as Sentry from "@sentry/browser"
import Push from "push.js"

import { BRAND_INFO } from "../config/setup"
import { AUDIO_NOTIFICATION } from "../assets"
import { uniqueId } from "./common"


const liveAgentAudio = new Audio(process.env.REACT_APP_CHAT_NOTIFICATION_SOUND)
liveAgentAudio.muted = true

const normalAudio = new Audio(AUDIO_NOTIFICATION)
normalAudio.muted = true

const blankFunction = () => {} //Browser handles everything itself

export const sendPushNotification = data => {
  if (Push.Permission.has() && data) {
    let audio = normalAudio
    const options = {
      tag: uniqueId("notification"),
      vibrate: [200, 100, 200],
      timeout: 2000,
      onShow: function () {
        try {

          if (data.isLiveAgentConnected && process.env.REACT_APP_CHAT_NOTIFICATION_SOUND) audio = liveAgentAudio

          if (audio && audio.paused) {
            let promise = audio.play()
            promise.catch(blankFunction)
            if (promise !== undefined) {
              audio
                .play()
                .then(() => {
                  audio.muted = false
                })
                .catch(blankFunction)
            }
          }
        } catch (error) {
          Sentry.captureException(error)
        }
      },
      onClick: function () {
        window.focus()
        this.close()
      },
      ...data,
    }
    Push.create(BRAND_INFO.NOTIFICATION_TITLE, options)
  }
}
